import { Userspaces } from "@busy-human/k9-library";
import { useAuth } from '../store/auth';
import { useLeads, Lead, LeadModel } from "@/store/useLeads";

/**
 * Take Lead info and Start a new Customer Collection Document
 */

const leadsState     = useLeads();
const auth = useAuth();

export async function leadToCustomer(leadId: string){
    console.group(" Lead to customer group start, ")
    let response: {
        success: boolean;
        message: string | any;
    } = {success: false, message: ""}
    let lead:LeadModel = leadsState?.selectedItem;
    // let selectedId = lead._id;
        try{
            let newUser = Object.assign(Userspaces.Defaults(), lead);
            let res = await auth.createUserAndResetPass(newUser);
            if (res.success){
                response = {success: true,message: "Success"}
            } else response = {success:false,message:res.reason};
        } catch (err) {
            console.error(" !-- leadToCustomer function was unable to create new user. responded with error: \n",err)
            response = {success:false,message:err};
        }
    console.groupEnd()
    return response
}